var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityGroupHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_1348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.95 4.89169C13.475 4.32502 13.7417 1.66669 10 1.66669L2.13333 10C3.13333 14.15 5.64166 16.475 10 18.3334L17.8667 10C18.1083 8.99169 18.2583 7.88335 18.3333 6.64169C18.375 5.80002 17.7833 5.03335 16.95 4.89169Z",
    fill: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66669V10H2.13335C1.89168 8.99169 1.74168 7.88335 1.66668 6.64169C1.62502 5.80002 2.21668 5.03335 3.05002 4.89169C6.52502 4.32502 6.25835 1.66669 10 1.66669Z",
    fill: "url(#paint0_linear_71_1348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8667 10C16.8667 14.15 14.3583 16.475 10 18.3333V10H17.8667Z",
    fill: "url(#paint1_linear_71_1348)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_1348",
    x1: 5.83231,
    y1: 1.66669,
    x2: 5.83231,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#4671F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_1348",
    x1: 13.9333,
    y1: 10,
    x2: 13.9333,
    y2: 18.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#4671F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCEEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_1348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityGroupHover);
export default __webpack_public_path__ + "static/media/security-group-hover.3fa25f17d8f1a7c4f01f2ddcd2105160.svg";
export { ForwardRef as ReactComponent };